
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const NewsUpdates = () => {
  const news = [
    {
      id: 1,
      category: 'Expansion',
      date: 'Dec 15, 2024',
      title: 'TrackVerse Opens New Hub in Singapore',
      excerpt: 'Strengthening our Asia-Pacific presence with a state-of-the-art logistics center.',
      image: 'https://public.readdy.ai/ai/img_res/8e9bf914e3c981efdc5db920a5b675d1.jpg',
      readTime: '3 min read',
    },
    {
      id: 2,
      category: 'Technology',
      date: 'Dec 10, 2024',
      title: 'AI-Powered Route Optimization Launched',
      excerpt: 'New machine learning algorithms reduce delivery times by up to 15%.',
      image: 'https://readdy.ai/api/search-image?query=futuristic%20logistics%20technology%20dashboard%20with%20AI%20analytics%20and%20route%20mapping%20digital%20interface%20modern%20clean%20design%20professional%20corporate%20imagery&width=400&height=250&seq=news-ai-002&orientation=landscape',
      readTime: '4 min read',
    },
    {
      id: 3,
      category: 'Sustainability',
      date: 'Dec 5, 2024',
      title: 'Carbon Neutral Shipping Now Available',
      excerpt: 'Eco-conscious logistics options for environmentally responsible businesses.',
      image: 'https://readdy.ai/api/search-image?query=sustainable%20green%20logistics%20electric%20delivery%20trucks%20and%20solar%20panels%20at%20modern%20warehouse%20eco%20friendly%20transportation%20professional%20photography&width=400&height=250&seq=news-green-003&orientation=landscape',
      readTime: '2 min read',
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row md:items-end md:justify-between mb-12"
        >
          <div>
            <div className="inline-block px-4 py-2 bg-primary-blue/10 rounded-lg text-sm font-semibold text-primary-blue uppercase tracking-wider mb-4 whitespace-nowrap">
              Latest Updates
            </div>
            <h2 className="font-heading text-4xl lg:text-5xl text-gray-900 font-bold">
              News & Insights
            </h2>
          </div>
          <Link
            to="/contact"
            className="mt-6 md:mt-0 inline-flex items-center text-primary-blue font-semibold hover:text-primary-green transition-colors cursor-pointer whitespace-nowrap"
          >
            View All News
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {news.map((item, index) => (
            <motion.article
              key={item.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-shadow group cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-primary-blue text-white text-xs font-semibold rounded-full whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-3">
                  <span>{item.date}</span>
                  <span className="mx-2">•</span>
                  <span>{item.readTime}</span>
                </div>
                <h3 className="font-semibold text-lg text-gray-900 mb-2 group-hover:text-primary-blue transition-colors">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {item.excerpt}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsUpdates;
